import React, { useState, useEffect } from 'react'
import { Box, Grid, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, FormHelperText, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getBaseCodes } from '../../../modules/auth';

import 'dayjs/locale/ko'; 
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; 
import DateAdapter from '@mui/lab/AdapterDateFns';
import * as dayjs from 'dayjs'

import _ from 'lodash';

const TechReqForm = ({ tech, formik }) => {
  
  const dispatch = useDispatch();

  const [techTypOptions, setTechTypOptions] = useState([]);

  const { baseCodes } = useSelector(
    ({ auth }) => ({
      baseCodes: auth.baseCodes,
      error: auth.baseCodesError,
    }),
  );


  const [workStDt, setWorkStDt] = useState(null);
  const [workEdDt, setWorkEdDt] = useState(null);

  useEffect(() => {
    if (tech) {
      if (tech.workStDt) setWorkStDt(tech.workStDt);
      if (tech.workEdDt) setWorkEdDt(tech.workEdDt);
    }
  }, [tech]);

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  useEffect(() => {
    if (!baseCodes) {
      dispatch(getBaseCodes());
    } else {
      let techTyps = _.filter(baseCodes, {
        blcCd: 'BASE',
        mlcCd: 'TECH',
        slcCd: 'TECH_TYP',
      });
      techTyps = _.orderBy(techTyps, ['step']);
      setTechTypOptions(techTyps);

    }
  }, [dispatch, baseCodes])

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Grid
        container
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={6}>
          <FormControl component="fieldset">
            <FormLabel component="legend">기술지원 타입</FormLabel>
            <RadioGroup
              row
              aria-label="workTyp"
              name="qteKind-buttons-group"
              value={formik.values.workTyp}
              onChange={(event) =>
                formik.setFieldValue('workTyp', event.target.value)
              }
            >
              {techTypOptions && techTypOptions.map((option, index) => (
                <FormControlLabel key={index} value={option.revVal2} control={<Radio />} label={option.revVal1} />
              ))}

              {formik.touched.workTyp && Boolean(formik.errors.workTyp) && (
                <FormHelperText>{formik.errors.workTyp}</FormHelperText>
              )}
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <DatePicker
              label="작업 요청 시작일"
              format="YYYY-MM-DD"
              mask={'____-__-__'}
              id="workStDt"
              name="workStDt"
              value={dayjs(workStDt)}
              onChange={(newValue) => {
                setWorkStDt(dayjs(newValue));
                onChangeDate(dayjs(newValue), 'workStDt');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  variant="outlined"
                  required
                  fullWidth
                  error={
                    formik.touched.workStDt &&
                    Boolean(formik.errors.workStDt)
                  }
                  helperText={
                    formik.touched.workStDt && formik.errors.workStDt
                  }
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <DatePicker
              label="작업 요청 종료일"
              format="YYYY-MM-DD"
              mask={'____-__-__'}
              id="workEdDt"
              name="workEdDt"
              value={dayjs(workEdDt)}
              onChange={(newValue) => {
                setWorkEdDt(dayjs(newValue));
                onChangeDate(dayjs(newValue), 'workEdDt');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  variant="outlined"
                  required
                  fullWidth
                  error={
                    formik.touched.workEdDt && Boolean(formik.errors.workEdDt)
                  }
                  helperText={
                    formik.touched.workEdDt && formik.errors.workEdDt
                  }
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      {formik.values?.workTyp === '기타' && (
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={12}>
            <TextField
              margin="normal"
              required={false}
              variant="outlined"
              fullWidth
              id="workTypDet"
              name="workTypDet"
              label="기술지원 - 기타 참고"
              value={formik.values.workTypDet}
              onChange={formik.handleChange}
              error={formik.touched.workTypDet && Boolean(formik.errors.workTypDet)}
              helperText={formik.touched.workTypDet && formik.errors.workTypDet}
            />
          </Grid>
        </Grid>
      )}

      <Grid
        container
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={12}>
          <TextField
            margin="normal"
            required
            variant="outlined"
            fullWidth
            multiline
            rows={5}
            id="workTxt"
            name="workTxt"
            label="기술지원 요청사항(상세 기술)"
            value={formik.values.workTxt}
            onChange={formik.handleChange}
            error={
              formik.touched.workTxt && Boolean(formik.errors.workTxt)
            }
            helperText={formik.touched.workTxt && formik.errors.workTxt}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default TechReqForm